<script>
import { scrollToAnchor } from '@/utils/scroll-to-anchor';

export default {
  name: 'Header',
  props: {
    vk: String,
    mailto: String,
    twoRow: Boolean,
  },
  methods: {
    scrollToAnchor,
  },
};
</script>

<template>
  <div :class="{header: true, 'header_two-row': twoRow}">
    <div class="header__left">
      <router-link to="/" class="header__item header__item_btn">
        Главная
      </router-link>
      <a href="#team" class="header__item header__item_btn" v-on:click="scrollToAnchor">
        Команда
      </a>
      <a href="#projects" class="header__item header__item_btn" v-on:click="scrollToAnchor">
        Проекты
      </a>
    </div>
    <div class="header__right">
      <div class="header__item header__item_desktop">
        Связаться с нами
      </div>
      <a :href="'https://' + vk" target="_blank" rel="noopener noreferrer" class="header__item header__item_icon">
        <i class="fab fa-vk"/>
      </a>
      <a :href="'mailto:' + mailto"
        target="_blank" rel="noopener noreferrer" class="header__item header__item_icon">
        <i class="fas fa-at"/>
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;

  &__left {
    display: flex;
  }

  &__right {
    display: flex;
  }

  &__item {
    display: flex;
    align-items: center;
    color: var(--main-bright);
    text-decoration: none;
    user-select: none;

    &:hover, &:active {
      color: var(--main-bright);
    }

    &:not(:last-child) {
      margin-right: 15px;
    }

    &_icon {
      font-size: 20px;
    }

    &_logo {
      font-weight: bold;
    }

    &_btn {
      --border-size: 2px;

      font-weight: bold;
      padding: 7px 15px;
      border-bottom: var(--border-size) solid var(--main-bright);
      border-top: var(--border-size)solid transparent;

      &:hover, &:active {
        color: var(--main-dark);

        border-top: var(--border-size) solid var(--main-bright);
        background: var(--main-bright);
      }
    }
  }
}

.header_two-row {
  flex-direction: column;
  align-items: center;

  .header__right {
    margin-top: 16px;
  }
}

@media(max-width: 800px) {
  .header__item_desktop {
    display: none;
  }
}
</style>
